import styled from "styled-components";

const FormBlock = styled.div``;

FormBlock.Apple = styled.div`
  margin-bottom: 20px;
`;
FormBlock.Method = styled.div`
  background: #ffffff;
  box-shadow: 0px 2px 10px rgba(0, 111, 135, 0.2);
  border-radius: 8px;
  padding: 12px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-bottom: 16px;
  position: relative;
  &:after {
    content: "";
    display: block;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    border-radius: 8px;
    border: 2px solid #24bde2;
  }
`;
FormBlock.Form = styled.div`
  margin-bottom: 24px;
`;
FormBlock.Button = styled.div``;

const CardInputWrapper = styled.div`
  background: ${(props) => (props.isValid ? "#ffffff" : "#ffffff")};
  border-radius: 12px;
  //padding: 17px 23px;
  height: 57px;
  width: 100%;
  box-sizing: border-box;
  transition: 0.3s;
  position: relative;
  :hover {
    border: 1px solid #00a1c6;
    border-radius: 8px;
  }
  border: ${(props) =>
    props.isComplete
      ? "1px solid #00A07A"
      : props.isValid
      ? "1px solid #D9D9D9"
      : "1px solid #EF6348"};
  :focus {
    outline: 0;
    outline-offset: 0;
  }
  &:focus-visible {
    outline: none;
  }
  .StripeElement {
    //margin-top: 10px;
    height: 100%;
    > div {
      height: 100%;
      transform: translate(17px, 23px);
    }
  }
  input {
    background: ${(props) => (props.isValid ? "transparent" : "transparent")};
    border-radius: 12px;
    border: none;
    width: 100%;
    box-sizing: border-box;
    transition: 0.3s;
    position: relative;
    font-weight: 400;
    height: 100%;
    font-family: SF, sans-serif;
    font-size: 16px;
    color: #325761;
    padding-top: 14px;
    padding-left: 16px;
    min-height: 18px;
    :active,
    :hover,
    :focus {
      outline: 0;
      outline-offset: 0;
    }
    &:focus-visible {
      outline: none;
    }
    &::placeholder {
      font-family: SF, sans-serif;
      font-style: normal;
      font-weight: 400;
      font-size: 17px;
      line-height: 110%;
      color: #7e969c;
    }
    &:-webkit-autofill {
      color: #d9d9d9;
      background-color: white !important;
    }
  }
`;

CardInputWrapper.Placeholder = styled.div`
  font-size: 17px;
  line-height: 20px;
  position: absolute;
  width: 100%;
  height: 100%;
  left: 20px;
  top: 17px;
  transform: translate(0);
  transition: 0.2s;
  p {
    transition: 0.2s;
  }
  &.active {
    p {
      font-size: 13px;
      transform: translate(-4px, -14px);
    }
  }
  &:hover {
    pointer-events: none;
    border: none !important;
  }
`;

CardInputWrapper.Paypal = styled(CardInputWrapper)`
  transition: 0.3s;
  border: ${(props) =>
    props.isValid ? "1px solid #D3D3D3" : "2px solid #CB6A4F"};
  border-radius: 3px;
`;

CardInputWrapper.Horizontal = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 17px;
`;

CardInputWrapper.Half = styled(CardInputWrapper)`
  width: 49%;
  position: relative;
  border-radius: 12px;
  padding-right: 60px;

  input {
    background: ${(props) => (props.isValid ? "#DCDCDC" : "#FFE8E8")};
    border-radius: 12px 0 0 12px !important;
    padding: 17px 23px;
    border: none;
    width: 100%;
    box-sizing: border-box;
    transition: 0.3s;
    position: relative;
    font-weight: 700;
    font-family: SF, sans-serif;
    font-size: 16px;
    color: #000000;
    :active,
    :hover,
    :focus {
      outline: 0;
      outline-offset: 0;
    }
    &:focus-visible {
      outline: none;
    }
    &::placeholder {
      font-family: SF, sans-serif;
      font-style: normal;
      font-weight: 500;
      font-size: 18px;
      line-height: 110%;
      color: #6c6c6c;
    }
  }
`;

CardInputWrapper.Message = styled.div`
  color: red;
  //position: absolute;
  //left: 2px;
  //top: 56px;
  font-size: 12px;
  text-align: left;
`;

CardInputWrapper.Message.Common = styled.div`
  background: #ef6348;
  border-radius: 8px;
  padding: 11px 12px;
  color: #ffffff;
  font-weight: 500;
  font-size: 12px;
  line-height: 14px;
  text-align: center;
  margin-top: 12px;
`;

CardInputWrapper.Icon = styled.div`
  position: absolute;
  left: 17px;
  top: 18px;
  &.cvv {
    right: 15px;
    left: auto;
    top: 16px;
    width: 30px;
  }
`;

CardInputWrapper.Tooltip = styled.div`
  position: absolute;
  right: 0px;
  bottom: 75px;
  width: 190px;
  padding: 20px;
  background: #ffffff;
  box-shadow: 0px 6px 16px rgba(0, 0, 0, 0.25);
  border-radius: 12px;
  box-sizing: border-box;
  text-align: left;
`;

CardInputWrapper.Tooltip.Arrow = styled.div`
  width: 50px;
  height: 50px;
  position: absolute;
  top: 100%;
  right: 0;
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
  overflow: hidden;
  &:after {
    content: "";
    position: absolute;
    width: 22px;
    height: 22px;
    background: #fff;
    -webkit-transform: translateX(-50%) translateY(-50%) rotate(45deg);
    transform: translateX(-50%) translateY(-50%) rotate(45deg);
    top: -5px;
    left: 50%;
    box-shadow: 0 4px 15px rgb(0 0 0 / 25%);
  }
`;

const Paragraph = styled.p`
  font-size: ${(props) => props.fs || 16}px;
  line-height: ${(props) => props.lh || 21}px;
  color: ${(props) => props.color || "#002E38"};
  text-align: ${(props) => props.ta || "left"};
  font-weight: ${(props) => props.fw || 400};
  &:hover {
    pointer-events: none;
    border: none !important;
  }
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex-grow: 1;
  min-height: var(--app-height);
  box-sizing: border-box;
`;

const Container = styled.div`
  max-width: 571px;
  width: 100%;
  box-sizing: border-box;
  margin-right: auto;
  margin-left: auto;
  padding: ${(props) => (props.removePadding ? 0 : "0 20px")};
  z-index: 1;
  display: flex;
  flex-direction: column;
  position: relative;
  flex-grow: 1;
`;
Container.Content = styled.div`
  max-width: 571px;
  width: 100%;
  box-sizing: border-box;
  margin-right: auto;
  margin-left: auto;
  padding-right: 15px;
  padding-left: 15px;
  z-index: 1;
  position: relative;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  div,
  p {
    -webkit-tap-highlight-color: transparent;
  }
`;

const FinishBlock = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
`;

FinishBlock.Top = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 4;
  justify-content: center;
  align-items: center;
  padding-top: 50px;
  padding-bottom: 50px;
`;
FinishBlock.Top.Logo = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 37px;
  img {
    width: 109px;
  }
`;
FinishBlock.Top.Content = styled.div``;
FinishBlock.Bottom = styled.div`
  flex-grow: 1;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const AfterBlock = styled.span`
  padding: 2px 5px 2px 6px;
  border-radius: 4px;
  background: ${(props) => props.bg || "#FFA73B"};
  color: ${(props) => props.textColor || "#ffffff"};
  font-size: ${(props) => props.fs || "14px"};
  font-weight: 900;
`;

export {
  FormBlock,
  CardInputWrapper,
  Paragraph,
  Wrapper,
  Container,
  FinishBlock,
  AfterBlock,
};
